import React from 'react';
import '@zeiss/zui';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getSubscription, getESBApiBaseUrl } from 'Utils/getBaseUrl';
import { useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    popper: {
        left: '50%',
        transform: 'translateX(-50%)',
    },
}));

export default function UserSelection({ onUserSelect }) {
    const [userList, setUserList] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const esbApiUrl = getESBApiBaseUrl();
    const token = useSelector((state) => state.userAccount.tokenId);
    const classes = useStyles();
    const debounceTimer = React.useRef();

    const handleInputChange = async (event, value) => {
        clearTimeout(debounceTimer.current);

        if (!value) {
            setUserList([]);
            setLoading(false); // Ensure loading stops if input is cleared
            return;
        }

        setLoading(true);
        debounceTimer.current = setTimeout(async () => {
            try {
                if (!esbApiUrl) {
                    throw new Error(
                        'API base URL is not configured. Check getESBApiBaseUrl().'
                    );
                }
                const esbSubscriptionKey = getSubscription();

                const finalUrl = `${esbApiUrl}/user?email=${value}`;

                const response = await fetch(finalUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json',
                        Accept: 'application/json',
                        'Access-Control-Allow-Origin': '*',
                        'EsbApi-Subscription-Key': esbSubscriptionKey,
                    },
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch users');
                }

                const result = await response.json();
                setUserList(Array.isArray(result) ? result : result.data);

                if (result.data.length === 0) {
                    setUserList([{ id: "-1", email: value }]);
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }, 500); // 500ms delay before making the API call
    };

    return (
        <>
            <Autocomplete
                options={userList}
                loading={loading}
                style={{
                    minWidth: 300,
                    width: '100%',
                    maxWidth: 500,
                    padding: '0 10px',
                    margin: '0 auto',
                }}
                classes={{
                    popper: classes.popper,
                }}
                disablePortal
                color="secondary"
                onChange={(event, selectedValue) => {
                    // Schritt 3: Die Callback-Funktion der Elternkomponente aufrufen

                    if (onUserSelect) {
                        onUserSelect(selectedValue);
                    }
                }}
                onInputChange={handleInputChange}
                getOptionLabel={(option) => option.name || option.email || ''}
                isOptionEqualToValue={(o, v) => o.id === v.id}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select user"
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {loading ? (
                                        <CircularProgress color="inherit" size={20} />
                                    ) : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}
                    />
                )}
            />
        </>
    );
}
